<ion-header>
  <ion-toolbar color="primary">
    <ion-title>
      {{ 'LOGIN.REGISTER_GUEST.DIALOGS.PIN_REGISTER.HEADER_TITLE' | translate }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="exit()">
        <ion-icon name="close" slot="icon-only"/>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-card>
    <ion-card-header>
      <ion-card-title>
        {{ 'LOGIN.REGISTER_GUEST.DIALOGS.PIN_REGISTER.SALUTE' | translate }}
      </ion-card-title>
    </ion-card-header>
    <ion-card-content class="card-padding">
      <span>{{ 'LOGIN.REGISTER_GUEST.DIALOGS.PIN_REGISTER.DESCRIPTION' | translate }}</span>&nbsp;
      <b>{{ email }}</b>
    </ion-card-content>
  </ion-card>
  <ion-card>
    <ion-card-header>
      <ion-card-title>
        {{ 'LOGIN.REGISTER_GUEST.DIALOGS.PIN_REGISTER.PIN.TITLE' | translate }}
      </ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <app-shared-pin-input (pinFormChanged)="onPinFormChanged($event)"/>
      <div class="note-wrapper">
        <ion-note>
          {{ 'LOGIN.REGISTER_GUEST.DIALOGS.PIN_REGISTER.PIN.NOTE' | translate }}
        </ion-note>
        <ion-note>
          {{ 'LOGIN.REGISTER_GUEST.DIALOGS.PIN_REGISTER.BUTTONS.NO_MAIL' | translate }}
          @if (!(isLoading$ | async)) {
            <a (click)="requestPinAgain()">
              {{ 'LOGIN.REGISTER_GUEST.DIALOGS.PIN_REGISTER.BUTTONS.TRY_AGAIN' | translate }}
            </a>
          }
        </ion-note>
      </div>
    </ion-card-content>
  </ion-card>
  <ion-card class="ion-no-padding card-button">

    <ion-button (click)="submit()"
                [disabled]="pinForm.invalid || isSubmitDisabled" class="submit" expand="block">
      {{ 'LOGIN.REGISTER_GUEST.DIALOGS.PIN_REGISTER.BUTTONS.SUBMIT' | translate }}
    </ion-button>
  </ion-card>
</ion-content>

